export default __webpack_public_path__ + "static/media/edit_icon.26c571b6.svg";